import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ArcadeHelperText, HelperText, PaddingInset } from '@cash-design-system/react'
import { FormBlocker } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'

import { HelpModal } from '../../../HelpModal/HelpModal'
import SpacerElement from '../SpacerElement/SpacerElement'

type HelpModalProps = Omit<React.ComponentProps<typeof HelpModal>, 'flow' | 'onClose'>

export const FormBlockerHelpAction = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  const { t } = useTranslation()
  const flow = useFlowContext()
  const blocker = flow.active?.blockerData?.blocker as FormBlocker
  const helpAction = blocker?.help_action

  if (!helpAction) {
    return null
  }

  const helpModalProps = ((): HelpModalProps | void => {
    if (helpAction.menu_action) {
      return {
        isOpen: isModalOpen,
        helpItems: (helpAction.menu_action?.actions ?? []).map(action => ({
          text: action.text,
          blocker_action: action,
        })),
      }
    }

    return {
      isOpen: isModalOpen,
      helpItems: [
        {
          text: helpAction.text ?? 'Help',
          blocker_action: helpAction,
        },
      ],
    }
  })()

  if (!helpModalProps) {
    return null
  }

  return (
    <>
      <SpacerElement proportion={1} />

      {isArcadeMigrationEnabled ? (
        <ArcadeHelperText onClick={() => setModalOpen(true)} tooltipText={t('Get help', { context: 'Help text.' })} />
      ) : (
        <PaddingInset>
          <HelperText onClick={() => setModalOpen(true)}>{t('Get help', { context: 'help option' })}</HelperText>
        </PaddingInset>
      )}

      <SpacerElement proportion={1} />
      <HelpModal
        {...helpModalProps}
        flow={flow}
        blockerActionOptions={{ replace: true }}
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        showInModal={true}
      ></HelpModal>
    </>
  )
}
